// project-imports
import rootReducers from '../reducers';
import { loadState, saveState } from './localStorage';

// third-party
import { configureStore } from '@reduxjs/toolkit';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';

// Reading data of localstorage from loadstate
const preloadedState = loadState();

// Configuring redux store
export const store = configureStore({
    reducer: rootReducers,
    preloadedState: preloadedState,
    devTools: process.env.REACT_APP_REDUX_HIDE_IN_PRODUCTION !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(createStateSyncMiddleware({})),
});

// Getting data from readucer on every state updation
store.subscribe(() => {
    saveState({
        blog: store.getState().blog,
        category: store.getState().category,
        courses: store.getState().courses,
        domain: store.getState().domain,
        enquiry: store.getState().enquiry,
        testimonial: store.getState().testimonial,
        filter: store.getState().filter,
        youtube: store.getState().youtube,
        instructor: store.getState().instructor,
        user: store.getState().user,
        orders: store.getState().orders,
        products: store.getState().products,
        stats: store.getState().stats,
        gallery: store.getState().gallery,
        interview: store.getState().interviewQuestions,
        quickInsights: store.getState().quickInsights,
        bug: store.getState().bug,

    });

});

// Syncronizing the redux state
initMessageListener(store);